import { useDebounce } from 'use-debounce';

/**
 * Returns a debounced copy of `value` that updates after `delayMs` of inactivity.
 * Keeps the source value snappy for the UI while delaying downstream effects (e.g. API queries).
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debouncedValue] = useDebounce(value, delayMs);
  return debouncedValue;
}
